import type { InputType } from 'config'

export const plainTextCostTypeItems: string[] = [
  'z_borrowerContingency',
  'z_lenderContingency',
  'z_borrowerFinancedRehabAmount',
  'z_constructionManagementFee',
  'z_mortgagePaymentEscrows',
]

/** Draw Type options (Budget + Trust Ledger share the same field) */
export const DRAW_TYPE_OPTIONS = [
  'Advancement',
  'Reimbursement Pro Rata',
  'Reimbursement After Delta',
  'Reimbursement Prior to Delta',
]

/** Map legacy stored labels to current Draw Type options */
export const normalizeDrawType = (value?: string | null): string => {
  if (!value) return ''
  if (value === 'Reimbursement') return 'Reimbursement Pro Rata'
  if (value === 'Advancement (Pmt Escrows Only)') return 'Reimbursement After Delta'
  return value
}

export const defaultInputs = (): Record<string, InputType> => {
  return {
    address: {
      inputType: 'map',
      title: 'Address',
      value: '',
    },
    drawType: {
      inputType: 'select',
      options: DRAW_TYPE_OPTIONS,
      title: 'Draw Type',
      value: '',
      hasDefaultOption: true,
    },
    constructionBudget: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Construction Budget',
      prefix: '$',
      value: '',
      readOnly: true,
    },
    constructionAmountFinanced: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Construction Amount Financed',
      prefix: '$',
      value: '',
      readOnly: true,
    },
    borrowerFinancedDrawType: {
      inputType: 'select',
      options: ['Not Applicable', 'Draw 00 (Borrower Expenses First)', 'Prorata (% of Rehab Cost)'],
      title: 'Borrower Financed Draw Type',
      value: '',
    },
    borrowerFinancedProRate: {
      inputType: 'text',
      type: 'text',
      title: 'Borrower Financed Pro Rate',
      value: '',
      prefix: '%',
      readOnly: true,
    },
    loanToFinancePrepaidAmounts: {
      inputType: 'select',
      options: ['True', 'False'],
      title: 'Loan To Finance Prepaid Amounts',
      value: '',
    },
    constructionManagementFee: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Construction Management Fee',
      prefix: '$',
      value: '',
    },
    CurrentSQFT: {
      inputType: 'text',
      type: 'number',
      title: 'Current SQFT',
      value: '',
      error: '',
    },
    AfterRehadSQFT: {
      inputType: 'text',
      type: 'number',
      title: 'After Rehab SQFT',
      value: '',
      error: '',
    },
    BedroomCount: {
      inputType: 'text',
      type: 'number',
      title: 'Bedroom Count',
      value: '',
      error: '',
    },
    BathroomCount: {
      inputType: 'text',
      type: 'number',
      title: 'Bathroom Count',
      value: '',
      error: '',
    },
    numberOfUnits: {
      inputType: 'text',
      type: 'number',
      title: 'Number of Units',
      value: '',
      error: '',
    },
    LotSize: {
      inputType: 'text',
      type: 'number',
      title: 'Lot Size',
      value: '',
      error: '',
    },
    YearBuilt: {
      inputType: 'text',
      type: 'number',
      title: 'Year Built',
      value: '',
      error: '',
    },
    narrative: {
      inputType: 'textarea',
      title: '',
      rows: 5,
      value: '',
      visible: false,
    },
  }
}
